import React from 'react';
import { Link } from 'react-router-dom';
import { FaCheckCircle, FaArrowRight, FaTrophy, FaUsers, FaMedal, FaHeart } from 'react-icons/fa';
import './About.css';

const RecreationalFitnessBadminton = () => {

    return (
        <div className="about-page">
            {/* Main About Section */}
            <section className="about-main section">
                <div className="container">
                    <div className="about-main-grid">
                        <div className="about-main-content">
                            <h2>Recreational & Fitness Badminton</h2>
                            <p>
                                The Recreational & Fitness Badminton program at Net Nest Badminton Sports Club is designed for individuals who want to enjoy badminton while improving their overall fitness in a relaxed, stress-free environment. This program is perfect for players who may not be aiming for competitive tournaments but want to stay active, healthy, and energetic through regular play.
                            </p>
                            <h2>Program Overview</h2>
                            <p>
                                Badminton is one of the most effective sports for maintaining physical fitness, and our Recreational & Fitness Badminton program combines fun gameplay with structured guidance. The focus is on enjoyment, movement, and health benefits rather than competition, making it suitable for beginners, adults, and working professionals.
                            </p>
                        </div>
                        <div className="about-main-images">
                            <img src="img/Recreational & Fitness Badminton.jpg" alt="Badminton Court" className="main-image" />
                        </div>
                    </div>
                    <div className="about-main-grid">
                        <div className="about-main-content">
                            <h2>Fitness-Focused Gameplay</h2>
                            <p>
                                Cardiovascular health
                                <br></br>
                                Stamina and endurance
                                <br></br>
                                Agility and flexibility
                                <br></br>
                                Muscle tone and coordination
                            </p>
                        </div>
                        <div className="about-main-images">
                            <h2>Skill Improvement in a Relaxed Setting</h2>
                            <p>
                                Correct grip and stroke guidance
                                <br></br>
                                Basic footwork and positioning
                                <br></br>
                                Rally control and shot consistency
                            </p>
                        </div>
                        <div className="about-main-images">
                            <h2>Stress Relief & Mental Well-Being</h2>
                            <p>
                                Mental relaxation and focus
                                <br></br>
                                Reduced work-related stress
                                <br></br>
                                Improved mood and energy levels
                            </p>
                        </div>
                        <div className="about-main-images">
                            <h2>Flexible Schedules for Busy Lifestyles</h2>
                            <p>
                                Working professionals
                                <br></br>
                                College students
                                <br></br>
                                Fitness enthusiasts
                                <br></br>
                                Adults returning to sports after a break
                            </p>
                        </div>
                        <div className="about-main-images">
                            <h2>Social & Community Experience</h2>
                            <p>
                                Friendly matches and group play
                                <br></br>
                                A welcoming and supportive community
                                <br></br>
                                Opportunities to make new friends
                            </p>
                        </div>
                        <div className="about-main-images">
                            <h2>Safe & Comfortable Playing Environment</h2>
                            <p>
                                Net Nest Badminton Sports Club provides well-maintained indoor courts with proper lighting and safe flooring. This ensures a comfortable playing experience while minimizing the risk of injuries.
                            </p>
                        </div>
                        <div className="about-main-images">
                            <h2>Who Should Join This Program?</h2>
                            <p>
                                Adults seeking fitness through sports
                                <br></br>
                                Beginners wanting casual badminton play
                                <br></br>
                                Working professionals looking for stress relief
                                <br></br>
                                Players interested in non-competitive badminton
                            </p>
                        </div>
                    </div>
                </div>
            </section>
        </div>
    );
};

export default RecreationalFitnessBadminton;
